import React, { useState, useEffect, useCallback } from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import EcosystemPage from "./pages/EcosystemPage";
import AboutPage from "./pages/AboutPage";
import CareersPage from "./pages/CareersPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import HostingPage from "./pages/HostingPage";

const ROUTE_MAP = {
  "/":           "home",
  "/hosting":    "hosting",
  "/ecosystem":  "ecosystem",
  "/about":      "about",
  "/careers":    "careers",
  "/faq":        "faq",
  "/contact":    "contact",
};

const PAGE_URL = {
  home:       "/",
  hosting:    "/hosting",
  ecosystem:  "/ecosystem",
  about:      "/about",
  careers:    "/careers",
  faq:        "/faq",
  contact:    "/contact",
};

function getInitialPage() {
  // Strip trailing slash so /faq/ and /faq both map correctly
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  return ROUTE_MAP[path] || "home";
}

export default function App() {
  const [activePage, setActivePage] = useState(getInitialPage);

  const navigate = useCallback((page) => {
    setActivePage(page);
    const url = PAGE_URL[page] || "/";
    window.history.pushState({ page }, "", url);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const handlePop = (e) => {
      const page = e.state?.page || getInitialPage();
      setActivePage(page);
    };
    window.addEventListener("popstate", handlePop);
    return () => window.removeEventListener("popstate", handlePop);
  }, []);

  const renderPage = () => {
    switch (activePage) {
      case "ecosystem": return <EcosystemPage navigate={navigate} />;
      case "about":     return <AboutPage navigate={navigate} />;
      case "careers":   return <CareersPage navigate={navigate} />;
      case "hosting":   return <HostingPage navigate={navigate} />;
      case "faq":       return <FAQPage navigate={navigate} />;
      case "contact":   return <ContactPage navigate={navigate} />;
      default:          return <HomePage navigate={navigate} />;
    }
  };

  return (
    <div className="min-h-screen text-zinc-700 flex flex-col">
      <Navbar activePage={activePage} navigate={navigate} />
      <main key={activePage} className="flex-1 animate-fade-in">
        {renderPage()}
      </main>
      <Footer navigate={navigate} />
    </div>
  );
}
